import { CoreOptions as AdyenOptions } from '@adyen/adyen-web/dist/types/core/types';
import dom from '../utils/dom';
import OnePageGivingForm, { StateFilterConfig } from './OnePageGivingForm';
import getCurrencyFormatter from '../tnew/currency/getCurrencyFormatter';
import { IRecaptchaSettings, RecaptchaService } from '../utils/RecaptchaService';
import PaymentProviderFactory from '../payment/PaymentProviderFactory';
import AnalyticsService from '../analytics/AnalyticsService';
import { IViewItemAnalytics } from '../analytics/types';

interface OnePageGivingConfig {
  recaptchaSettings: IRecaptchaSettings;
  stateFilterConfig?: StateFilterConfig;
  paymentConfiguration: AdyenOptions;
  paymentComponentConfig?: object;
  viewItemAnalytics?: IViewItemAnalytics;
}

const initForm = async (config: OnePageGivingConfig) => {
  if (config.viewItemAnalytics) {
    AnalyticsService.trackViewItem(config.viewItemAnalytics);
    AnalyticsService.pushEcommerceItems(config.viewItemAnalytics.items);
  }

  const currencyFormatter = await getCurrencyFormatter();
  const $form = dom.find('.tn-opg-form') as HTMLFormElement;
  const recaptchaService = new RecaptchaService($form, config.recaptchaSettings);

  let onePageGivingFormInstance: OnePageGivingForm;

  if (config.paymentComponentConfig) {
    config.paymentComponentConfig.onAuthorizeFailed = function (event) {
      const { responseBody } = event.detail;
      event.preventDefault();

      onePageGivingFormInstance.onAuthorizeFailed(responseBody);
    };
  }

  const paymentComponentConfiguration = config.paymentComponentConfig ? {
    ...config.paymentComponentConfig,
    onSubmit: (state: object) => { },
    onError: (error: object) => {
      console.error(error);
    },
  } : undefined;
  const paymentProvider = PaymentProviderFactory.create({
    adyenOptions: config.paymentConfiguration,
    paymentComponentConfiguration,
  });

  onePageGivingFormInstance = new OnePageGivingForm($form, currencyFormatter, recaptchaService, config.recaptchaSettings, config.paymentConfiguration, config.stateFilterConfig, paymentProvider, config.viewItemAnalytics);
};

window.tnew.page.initialize = (config: OnePageGivingConfig) => {
  window.history.scrollRestoration = 'manual';
  window.addEventListener('unload', () => { });

  initForm(config);
};
